__turbopack_context__.v({
  "faqElement": "br3V6W_faqElement",
  "h2": "br3V6W_h2",
  "root": "br3V6W_root",
});
